/* eslint-disable react/prop-types */
/* This is the same as the side-nav-menu-item, product-menu-item, sub-nav-start-item, sub-nav-end-item renderers and is going to be replaced with a generic solution */

var type = '@sitebase/product-menu-item';

export default {
  type: type,
  render: function render(_ref) {
    var label = _ref.data.label;
    return label;
  }
};
//# sourceMappingURL=product-menu-item.js.map